import { Action } from 'redux';
export const GET_MY_ACCTOUNT_PAGE_CONTENTS = 'driver-home-page/GET_MY_ACCTOUNT_PAGE_CONTENTS';
export const PERSIST_MY_ACCTOUNT_PAGE = 'driver-home-page/PERSIST_MY_ACCTOUNT_PAGE';
export const GET_DRIVER_MY_ACCOUNT_PAGE_CONTENTS = 'driver-home-page/GET_DRIVER_MY_ACCOUNT_PAGE_CONTENTS';
export const UPDATE_DRIVER_MY_ACCOUNT_PAGE = 'driver-home-page/UPDATE_DRIVER_MY_ACCOUNT_PAGE';
/**
 * Get home page contents
 */
export interface GetMyAcctountPageContentsAction extends Action<typeof GET_MY_ACCTOUNT_PAGE_CONTENTS> {
  payload: any;
}

export const getMyAccountPageContents = (data: any): GetMyAcctountPageContentsAction => ({
  type: GET_MY_ACCTOUNT_PAGE_CONTENTS,
  payload: data,
});

export const getDriverMyAcctountPageContents = () => {
  return {
    type: GET_DRIVER_MY_ACCOUNT_PAGE_CONTENTS,
  };
};

export const persistMyAccountPage = (data: any) => ({
  type: PERSIST_MY_ACCTOUNT_PAGE,
  payload: data,
});
export const updateDriverMyAccountPage = (data: any) => {
  return {
    type: UPDATE_DRIVER_MY_ACCOUNT_PAGE,
    payload: data,
  };
};
